import { useState, useCallback, useRef } from 'react';

interface UseCopyToClipboardOptions {
  resetDelay?: number;
}

export function useCopyToClipboard({ resetDelay = 2000 }: UseCopyToClipboardOptions = {}) {
  const [copiedId, setCopiedId] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const copy = useCallback(
    async (text: string, id?: string) => {
      try {
        await navigator.clipboard.writeText(text);
      } catch {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }

      const resolvedId = id ?? text;
      setCopiedId(resolvedId);

      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopiedId(null), resetDelay);
    },
    [resetDelay],
  );

  return { copiedId, copy } as const;
}
